/**
 * Organization Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SortOrder = {
    Ascending: 'Ascending',
    Descending: 'Descending'
} as const;
export type SortOrder = typeof SortOrder[keyof typeof SortOrder];

